import Navb from "./Navb";
import estilos from './servicios/Nav.module.css';
import {ReactComponent as Logonav} from '../../img/logos/logonav.svg';
import { 
  NavLink,
 } from "react-router-dom";

function Nav() {
  return (
    <div id='navB' className={estilos.nav}>
        <h1 className="flex items-center justify-between"> 
          <div>
            <Logonav className={estilos.img}></Logonav>
          </div>
          Taller Automotriz <br />Guerrero´s
        </h1>

      <nav id="sidebar">
        <NavLink
          to="/"
          className={({ isActive, isPending }) =>
            `${isPending ? estilos.pending : isActive ? estilos.active : ''}`
          }
        >
          <Navb
            titulo="Principal"
            className={({ isActive, isPending }) =>
              `${isPending ? estilos.pending : isActive ? estilos.active : ''}`
            }
          />
        </NavLink>

        <NavLink
          to="/Service/2"
          className={({ isActive, isPending }) =>
            `${isPending ? estilos.pending : isActive ? estilos.active : ''}`
          }
        >
          <Navb
            titulo="Servicios"
            className={({ isActive, isPending }) =>
              `${isPending ? estilos.pending : isActive ? estilos.active : ''}`
            }
          />
        </NavLink>

        <NavLink
          to="/Contact/3"
          className={({ isActive, isPending }) =>
            `${isPending ? estilos.pending : isActive ? estilos.active : ''}`
          }
        >
          <Navb
            titulo="Contacto"
            className={({ isActive, isPending }) =>
              `${isPending ? estilos.pending : isActive ? estilos.active : ''}`
            }
          />
        </NavLink>
      </nav>

    </div>
  );
};

export default Nav;
